import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute('/offerings/')({
  component: OfferingsIndex,
});

function OfferingsIndex() {
  return (
    <div className="flex h-fit min-h-screen w-screen flex-col items-center bg-background-50 py-10">
      <DocumentHead
        titleKey="page.offerings.title"
        descriptionKey="page.offerings.description"
        appendAppName={false}
      />
      <div className="flex w-full max-w-panel-full flex-col p-4">
        <h1 className="mb-6 text-2xl font-bold text-text-950">
          <FormattedMessage defaultMessage="Specialerbjudanden" />
        </h1>
        <p className="text-text-800">
          <FormattedMessage defaultMessage="Du väljer ett erbjudande genom att ange korrekt länk" />
        </p>
      </div>
    </div>
  );
}
